import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ExitIntentModal = ({ show, onHide, slug, onSelectCity }) => {
  return (
    <Modal show={show} onHide={onHide} centered className="exit-modal">
      <Modal.Header closeButton >
        {/* Only Cross Button */}

      </Modal.Header>

      <Modal.Body className="text-center">
        {/* Title Below Cross */}
        <Modal.Title className="w-100 text-center text-dark fw-bold mb-1">
          🎉 Get 10% To 30% Off On All Spiritual Services!
        </Modal.Title>

        <p className="service-one__item__text flex-grow-1 mt-3" style={{ color: 'black', fontFamily: 'poppins' }} >
          Download App & Get <strong>30% Off</strong> On Puja Samagri <strong>10% Off </strong> On Puja.
        </p>

        {/* App Download Button */}
        <div className="d-flex justify-content-center gap-3 my-3">
          <Button
            // variant="dark"
            className="d-flex align-items-center gap-2 text-transform-none"
            href="https://play.google.com/store/apps/details?id=spiritualapp.myomnamo&pli=1"
            target="_blank"
            rel="noopener noreferrer"
            style={{ backgroundColor: '#a52444', border: 'none' }}
          >
            <i className="fa-brands fa-google-play"></i>
            <span>Download on Play Store</span>
          </Button>
        </div>
      </Modal.Body>


    </Modal>

  );
};

export default ExitIntentModal;
